var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile"},[_c('img',{staticClass:"iconInfo",attrs:{"src":require("./../../assets/iconInfo.png")}}),_c('div',{staticClass:"row-1"},[_vm._v(" 为了保证良好的体验 "),_c('br'),_vm._v("请在PC端打开项目信息站 ")]),_c('div',{staticClass:"row-2"},[_vm._v("项目信息站地址：https://pip.itcast.cn")])])
}]

export { render, staticRenderFns }